import { Component, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';

/**
 * Generated class for the LubbuModalHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'lubbu-modal-header',
  templateUrl: 'lubbu-modal-header.html'
})
export class LubbuModalHeaderComponent {
  @Input() public title: string;
  @Input() public hideClose: boolean = false;
  @Output() cancel = new EventEmitter();

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/lubbu-modal-header/lubbu-modal-header.ts